<template>
    <div>
        <el-row :gutter="10">
            <el-col :span="6">
                <el-form ref="form" :model="form" label-width="80px">
                    <div><span style="color:#5f5d5d;font-weight: bold;line-height:30px;">筛选</span></div>
                    <el-form-item label="所属街镇">
                        <town-com v-on:on-selectLast="streetSelectHandler"></town-com>
                    </el-form-item>
                    <el-form-item label="企业名称">
                        <el-input placeholder="输入关键字进行过滤" v-model="filterText" style="max-width:221px;">
                        </el-input>
                    </el-form-item>
                    <div style="padding-top:10px">
                        <div><span style="color:#5f5d5d;font-weight: bold;line-height:30px;">企业列表</span></div>
                        <el-tree class="filter-tree" :data="data" :props="defaultProps" default-expand-all
                            :filter-node-method="filterNode" @node-click="handleNodeClick" ref="tree">
                            <div slot-scope="{node, data}" style="position:relative;">{{ data.label }} <span
                                    class="reviewCount" v-if="data.reviewCount > 0" title="待查阅数量">{{ data.reviewCount
                                    }}</span></div>
                        </el-tree>
                    </div>
                </el-form>
            </el-col>
            <el-col :span="18">
                <el-card class="box-card">
                    <div slot="header" class="clearfix" style="height:20px;">
                        <el-button size="mini" type="success" style="float: right; " :disabled="form.sub_size <= 0"
                            @click="handleUpdate()">批量审阅</el-button>
                    </div>
                    <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
                        @selection-change="handleSelectionChange" header-row-class-name="weightHeader">
                        <el-table-column prop="materialId" type="selection" :selectable="checkedEnable" width="55">
                        </el-table-column>
                        <el-table-column label="序号" width="55">
                            <template scope="scope">
                                {{ scope.$index + 1 }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="materialName" label="材料名称" width="280">
                        </el-table-column>
                        <el-table-column prop="authTime" label="提交时间">
                            <template slot-scope="scope"><span
                                    v-html="dateFormat(scope.row.authTime)"></span></template>
                        </el-table-column>
                        <el-table-column label="状态" width="90">
                            <template slot-scope="scope"><span :title="scope.row.subId"
                                    v-html="status(scope.row)"></span></template>
                        </el-table-column>
                        <el-table-column fixed="right" label="操作" width="260">
                            <template slot-scope="scope">
                                <el-button size="mini" v-if="scope.row.status >= 3"
                                    @click="handleClick(scope.row)">查看资料</el-button>
                                <el-button size="mini" v-if="scope.row.status >= 3 && !scope.row.previewType"
                                    type="success" @click="handleUpdate(scope.row)">审阅</el-button>
                                <el-button size="mini" v-if="scope.row.status >= 3" type="danger"
                                    @click="handlePreview(scope.row)">审阅情况</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>

            </el-col>
        </el-row>


        <el-dialog :fullscreen="false" title="各部门查阅情况" :visible.sync="dialogDepVisible" v-if="dialogDepVisible">
            <dep-components :id="currentSubId" @success="close(true)" @close="close()"></dep-components>
        </el-dialog>


        <el-dialog :fullscreen="false" title="材料审阅" :visible.sync="dialogReviewVisible" v-if="dialogReviewVisible">
            <div style="padding:20px 25px;color:#ff991d;font-size:16px;" v-if="form.batch_tips">
                <div v-html="form.batch_tips"></div>
            </div>
            <depreview-components :id="currentSubId" :ids="form.sub_ids" @success="close(true)"
                @close="close()"></depreview-components>
        </el-dialog>

        <el-dialog title="合同签署页面" :visible.sync="webFrameDiglog" width="90%">
            <iframe name="webFrame" id="webFrame" style="width:100%;" height="550px" class="iframe" :src="webFrameUrl"
                frameborder="0"></iframe>
        </el-dialog>
    </div>
</template>
<script>
import { enterpriseAll } from "../../../api/admin/sysEnterprise";
import { contractPage, materialList } from "../../../api/admin/sysEnterpriseMaterial";
import TownCom from "../common/town-com.vue";
import DepComponents from "./DepComponents.vue";
import DepreviewComponents from "./DepReviewComponents.vue";
import { download } from "../../../api/admin/sysFiles/index";

export default {
    components: {
        TownCom, DepComponents, DepreviewComponents
    },
    watch: {
        filterText(val) {
            this.$refs.tree.filter(val);
        }
    },
    computed: {
    },
    mounted() {
        this.loadEntTree();
    },
    methods: {
        checkedEnable: function (row, index) {
            if (row.status >= 3 && !row.previewType) {
                return true;
            }
            return false;
        },
        status(row) {
            let status = row.status;
            if (row.previewType) {
                if (row.previewType == 1) {
                    return "审阅通过"
                } else if (row.previewType == 2) {
                    return "审阅驳回"
                }
            }
            if (status == 3) { return "待审阅" }
            else if (status == 4) { return "审阅驳回" }
            else if (status == 5) { return "审阅通过" }
            else { return "<span style='color:red'>未提交</span>" }
        },
        materialType(materialType) {
            if (materialType == 0) { return "附件" }
            else if (materialType == 1) { return "录入" }
            else { return "附件或录入" }
        },
        filterNode(value, data) {
            if (!value) return true;
            return data.label.indexOf(value) !== -1;
        },
        handleSelectionChange(val) {
            this.form.sub_ids = val.map(x => x.subId);
            this.form.sub_size = this.form.sub_ids.length;
        },
        handleNodeClick(data) {
            this.listQuery.entId = data.id;
            this.getList();
        },
        getList() {
            materialList({ ...this.listQuery }).then(response => {
                if (response) {
                    this.tableData = response;
                } else {
                    this.tableData = [];
                }
            });
        },
        streetSelectHandler: function (id) {
            this.listQuery.addressStreetId = id;
            this.loadEntTree();
        },
        handleClick: function (row) {
            if (row.contractId) {
                //合约H5预览页面
                contractPage({ contractId: row.contractId }).then(response => {
                    this.webFrameDiglog = true;
                    this.webFrameUrl = response;
                })
            } else if (row.filePath) {
                //文件页面
                download(row.filePath);
            }
        },
        handleUpdate: function (row) {
            this.form.batch_tips = "";
            if (row) {
                this.form.sub_ids = null;
                this.form.sub_size = 0;
                this.currentSubId = row.subId;
                this.dialogReviewVisible = true;
            } else {
                if (this.form.sub_size && this.form.sub_size > 0) {
                    this.currentSubId = null;
                    this.form.batch_tips = "<i class='el-icon-warning'></i>您当前正在对 " + this.form.sub_size + " 份材料进行批量审核操作!";
                    this.dialogReviewVisible = true;
                }
            }
        },
        handlePreview: function (row) {
            this.currentSubId = row.subId;
            this.dialogDepVisible = true;
        },
        loadEntTree: function () {
            enterpriseAll(this.listQuery).then(data => {
                this.data = data.map(x => {
                    return { "id": x.entId, "label": x.entName, "reviewCount": x.reviewCount };
                });
            })
        },
        close(flush) {
            this.dialogDepVisible = false;
            this.dialogReviewVisible = false;
            flush && this.getList();
        },
        dateFormat(date) {
            return !date ? "" : date + "  " + this.dateDiffer(date);
        },
        dateDiffer(Date_end) {
            if (!Date_end) { return; }
            //date1结束时间
            let date1 = new Date(Date_end);
            //date2当前时间
            let date2 = new Date();
            date1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
            date2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
            const diff = date2.getTime() - date1.getTime(); //目标时间减去当前时间
            const diffDate = diff / (24 * 60 * 60 * 1000);  //计算当前时间与结束时间之间相差天数
            return diffDate <= 0 ? "" : "<br/>已过去<span style='color:red'>" + Math.abs(diffDate) + "天";
        }
    },
    props: ["activeName"],
    data() {
        return {
            currentSubId: 0,
            dialogDepVisible: false,
            dialogReviewVisible: false,
            webFrameDiglog: false,
            webFrameUrl: null,
            listQuery: {
                entId: null,
                addressStreetId: null,
                queryEnt: true
            },
            form: {
                sub_ids: [],
                sub_size: 0,
                batch_tips: "",
            },
            filterText: '',
            data: [],
            defaultProps: {
                children: 'children',
                label: 'label'
            },
            tableData: [
            ]
        };
    }
};
</script>
<style>
.weightHeader {
    font-size: 15px;
    color: #575858;
    font-weight: bold;
}

.reviewCount {
    position: absolute;
    right: -20px;
    top: 2px;
    font-size: 12px;
    color: rgb(255, 255, 255);
    background: red;
    /* padding: 2px 4px; */
    border-radius: 30px;
    width: 20px;
    display: flex;
    height: 20px;
    justify-content: center;
    align-items: center;
}
</style>
